import * as tokens from '../../../../../tokens/box-shadow.dark.generated.js';
export const globalBoxShadowDark = {
    boxShadow: {
        elevation: {
            level1: tokens.GLOBAL_BOX_SHADOW_ELEVATION_LEVEL1_DARK,
            level2: tokens.GLOBAL_BOX_SHADOW_ELEVATION_LEVEL2_DARK,
            level3: tokens.GLOBAL_BOX_SHADOW_ELEVATION_LEVEL3_DARK,
            level4: tokens.GLOBAL_BOX_SHADOW_ELEVATION_LEVEL4_DARK
        }
    }
};
//# sourceMappingURL=box-shadow.dark.js.map